import sha256 from "crypto-js/sha256";

export const hash256 = (password: string): string => {
  const hashDigest = sha256(password);
  return hashDigest.toString();
};
